module.exports = __webpack_public_path__ + "0d6e8e2a2cbe7aec4d569641d2547045.svg";